import { render, staticRenderFns } from "./GroupNotesItemRightBar.vue?vue&type=template&id=5c373e84&"
import script from "./GroupNotesItemRightBar.vue?vue&type=script&lang=js&"
export * from "./GroupNotesItemRightBar.vue?vue&type=script&lang=js&"
import style0 from "./GroupNotesItemRightBar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports